import { cloudinaryVideoUrl } from 'base/lib/cloudinary_url'

// This function helps apply some default transformations to video urls
// for performance reasons. Do not use if you already have transformations
// included in your cloudinary url, they will be overwritten.
export default {
  videoUrl: function (video = '', options = {}) {
    const matches = video.match(/v[0-9]{1,}.*/)

    if (!matches)
      console.warn(
        `The passed video url: ${video} doesnt match the pattern we were expecting.
        VideoHelper is intended to be used with cloudinary videos`,
      )
    const publicId = matches && matches[0] ? matches[0] : video

    return cloudinaryVideoUrl(publicId, options)
  },
}
